import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual, cloneDeep } from 'lodash'

// Modals
import PriceModelLogModal from '../../../shared/modals/PriceModelLogModal'

// Actions
import { getPriceList, updatePriceList, reorderPriceListItem } from '../../../actions/priceModel'
import { getCustomers } from '../../../actions/customers'
import { triggerPopup } from '../../../actions/backdrop'

import { getBrands } from '../../../actions/common'

import { createConfigContext, getTaskPriceConfig, getBodyTaskPriceConfig, getAddonStartTimeConfig, getAddonPartConfig } from './config'

// import styles
import './salescar.scss'

// Utils
// formatCurrency, reverseFormatCurrency
import { formatCurrency2, reverseFormatCurrency2 } from '../../../utils/currency'
import { renderFullDate, formatDate } from '../../../utils/time'
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
import { transformPercent, onPercentFocus } from '../../../utils/percent'
import { translation } from '../../../utils/helpers'

// import components
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'
// import HelpText from '../../../shared/components/HelpText'
import PriceItemGroup from '../PriceItemGroup'

// Elements
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import PanelHeader from '../../../shared/elements/panelHeader'
import Text from '../../../shared/elements/text'
import Switch from '../../../shared/elements/switch'
import Radio from '../../../shared/elements/radio'
import DateTime from '../../../shared/elements/datetime'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Button from '../../../shared/elements/button'
import Inline from '../../../shared/elements/inline'
import Grid from '../../../shared/elements/grid'
import DropDown from '../../../shared/elements/dropDown'
import DecimalInput from '../../../shared/components/DecimalInput'
import TableContainer from '../../../shared/elements/tableContainer'
import TableHeader from '../../../shared/elements/tableHeader'
import TableRow from '../../../shared/elements/tableRow'
import HelpIcon from '../../../shared/elements/helpIcon'
import TableExpand from '../../../shared/elements/tableExpand'
import RemoveButton from '../../../shared/elements/removeButton'
import AddButton from '../../../shared/elements/addButton'
import Check from '../../../shared/elements/check'

class Salescar extends Component {

  constructor (props) {
    super(props)
    this.state = {
      showPriceModelLog: false,
      log: [{
        ChangeTable: 0,
        ChangeTableId: 0,
        ChangeField: 0,
        PartItemId: 0,
        ChangeType: 0,
        ChangedById: 0,
        ChangedByName: null,
        ChangedAt: '',
        From: 0,
        To: 0,
        FromText: null,
        ToText: null
      }],
      priceOriginal: {},
      price: {},
      parts: [],
      bodyParts: [],
      new_startprice: {
        Price: '',
        AE: '',
        Mat: '',
        Env: '',
        Net: '',
        Discount: '',
        Total: '',
        Type: 0
      },
      new_startprice1: {
        Price: '',
        AE: '',
        Mat: '',
        Env: '',
        Net: '',
        Discount: '',
        Total: '',
        Type: 1
      },
      new_indexAdjust: {
        IndexAdjustmentId: 0,
        Date: '',
        Amount: 0,
        IsApplied: false,
        IsDeleted: false
      },
      confirm: {
        open: false,
        type: 0
      },
      confirmActive: {
        open: false,
        type: 0
      },
      confirmDelete: {
        open: false
      },
      IsWorking: false,
      ShopId: 0,
      customers: [],
      dimensions: {
        width: 0,
        height: 0
      },
      department: 0,
      config: null,
      currentBrand: 0,
      currentCustomer: 0
    }
    this.AERounding = 5
    this.switchRecommended = this.switchRecommended.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onInputBlur = this.onInputBlur.bind(this)
    // this.renderPartItem = this.renderPartItem.bind(this)
    // this.renderPartItemTask = this.renderPartItemTask.bind(this)
    this.changeType = this.changeType.bind(this)
    this.renderAddonParts = this.renderAddonParts.bind(this)
    this.renderPriceModelLog = this.renderPriceModelLog.bind(this)
    this.renderIndexAdjustments = this.renderIndexAdjustments.bind(this)
    this.showPriceModelLog = this.showPriceModelLog.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)

    this.moveItem = this.moveItem.bind(this)
    this.getItemListName = this.getItemListName.bind(this)
    this.getItemIdField = this.getItemIdField.bind(this)
    this.updateOrAddItem = this.updateOrAddItem.bind(this)
    this.deleteItem = this.deleteItem.bind(this)

    this.getConfirmActiveText = this.getConfirmActiveText.bind(this)

    // this.renderTaskPriceParts = this.renderTaskPriceParts.bind(this)
    // this.getTaskPriceConfig = getTaskPriceConfig.bind(this)
  }

  componentDidMount () {
    this.getPriceList(this.props)
    window.addEventListener('resize', this.updateDimensions)
    this.updateDimensions()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions () {
    let w = window
    let d = document
    let documentElement = d.documentElement
    let body = d.getElementsByTagName('body')[0]

    let width = w.innerWidth || documentElement.clientWidth || body.clientWidth
    let height = w.innerHeight || documentElement.clientHeight || body.clientHeight

    this.setState({
      dimensions: {
        width: width,
        height: height
      }
    })
  }

  dimensionShow (dimensions) {
    let show = false
    dimensions.map((val, key) => {
      if (!show) {
        let higherThan = val[0]
        let lessThan = val[1]
        let width = this.state.dimensions.width
        if (width > higherThan && width < lessThan) show = true
      }
    })
    return show
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(nextProps.item, this.props.item)) {
      this.setState({
        price: {},
        priceOriginal: {},
        parts: [],
        bodyParts: [],
        new_startprice: {
          Price: '',
          AE: '',
          Mat: '',
          Env: '',
          Net: '',
          Discount: '',
          Total: '',
          Type: 0
        },
        new_startprice1: {
          Price: '',
          AE: '',
          Mat: '',
          Env: '',
          Net: '',
          Discount: '',
          Total: '',
          Type: 1
        },
        new_indexAdjust: {
          IndexAdjustmentId: 0,
          Date: '',
          Amount: 0,
          IsApplied: false,
          IsDeleted: false
        },
        Log: [{
          ChangeTable: 0,
          ChangeTableId: 0,
          ChangeField: 0,
          PartItemId: 0,
          ChangeType: 0,
          ChangedById: 0,
          ChangedByName: null,
          ChangedAt: '',
          From: 0,
          To: 0,
          FromText: null,
          ToText: null
        }],
        department: 0
      })
      this.getPriceList(nextProps)
    }
  }

  componentWillUpdate (nextProps) {
    // Fix to missing brands
    if (nextProps.brands === null || nextProps.brands.length === 0) {
      this.props.getBrands()
    }
  }

  getPriceList (props) {
    props.getPriceList(props.item.PriceModelId).then((res) => {
      this.setState({
        price: res.data,
        priceOriginal: cloneDeep(res.data),
        department: res.data.Department
      })
      this.mapParts(res.data)
    }, () => {
      // Toastr
      window.toastr.error(translation('13445'), translation('216'))
      this.props.onShouldUpdate()
    })
  }

  shouldUpdatePrices (val1, val2) {
    return val1 !== val2
  }

  updatePrices (price) {
    const setPriceState = (data) => {
      this.setState({
        price: data,
        priceOriginal: cloneDeep(data),
        new_startprice: {
          Price: '',
          AE: '',
          Mat: '',
          Env: '',
          Net: '',
          Discount: '',
          Total: '',
          Type: 0
        },
        new_startprice1: {
          Price: '',
          AE: '',
          Mat: '',
          Env: '',
          Net: '',
          Discount: '',
          Total: '',
          Type: 1
        },
        new_indexAdjust: {
          IndexAdjustmentId: 0,
          Date: '',
          Amount: 0,
          IsApplied: '',
          IsDeleted: false
        },
        ShopId: 0,
        customers: [],
        Log: [{
          ChangeTable: 0,
          ChangeTableId: 0,
          ChangeField: 0,
          PartItemId: 0,
          ChangeType: 0,
          ChangedById: 0,
          ChangedByName: null,
          ChangedAt: '',
          From: 0,
          To: 0,
          FromText: null,
          ToText: null
        }],
        department: data.Department
      })
      this.mapParts(data)
    }
    this.setState({ IsWorking: true })
    return this.props.updatePriceList(price).then((res) => {
      setPriceState(res.data)
      this.setState({ IsWorking: false })
      // Toastr
      // window.toastr.success(translation('13444'), translation('13424'))
      // Return
      return res
    }, (err) => {
      this.setState({ IsWorking: false })
      // console.log('Error response ', err.response.data.Error)
      let errorDescription = null
      switch (err.response.data.Error) {
        case 1: // Conflict with existing
          errorDescription = '1793'
          break
        case 2: // Not allowed
          errorDescription = '1794'
          break
        case 1000: // Unspecified error
          errorDescription = '1795'
          break
      }
      if (errorDescription !== null) {
        // Toastr
        window.toastr.error(translation('13445') + ':</br>' + translation(errorDescription), translation('216'))
      } else {
        // Toastr
        window.toastr.error(translation('13445'), translation('216'))
      }

      // console.log('error ', err.response)
      setPriceState(err.response.data)
      // this.props.router.push('/prices')
      // Return
      return err
    })
  }

  onlyShow () {
    if (hasAccess([1, 6], this.props.auth.user.UserType) && this.state.price.UseRecommended || parseInt(this.props.auth.user.ShopId, 10) !== this.state.price.ShopId) {
      return true
    }
    return false

    // Old
    // if (this.state.price.UseRecommended) {
    //   if (hasAccess([1], this.props.auth.user.UserType)) {
    //     return false
    //   }
    //   return true
    // }
    // return false
  }

  mapParts (data) {
    let newData = []
    // Parts
    data.Parts.map((val, index) => {
      newData[val.PartItemId] = {
        part: val,
        tasks: []
      }
    })
    // Tasks
    if (data.Department === 0) {
      data.TaskPrices.map((val, index) => {
        newData[val.PartItem.PartItemId].tasks.push(val)
      })
      this.setState({
        parts: newData,
        bodyParts: []
      })
    } else {
      data.BodyTaskPrices.map((val, index) => {
        // console.log('bodytaskrpicemap', val, index)
        newData[val.PartItem.PartItemId].tasks.push(val)
      })
      this.setState({
        parts: [],
        bodyParts: newData
      })
    }
    console.log('data to map:', data)
  }

  onInputChange (e) {
    e.persist()
    let value = transformPercent(e.target.value, true)
    let name = e.target.name
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    if (e.target.name === 'Name') {
      value = e.target.value
    }
    this.setState({
      price: {
        ...this.state.price,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'checkbox') {
        this.updatePrices(this.state.price).then((res) => {
          if (name === 'Active') {
            this.props.getPriceLists(this.props)
          }
        })
      }
    })
  }

  onInputBlur (e) {
    let name = e.target.name
    if (name === 'PriceHourly') {
      let value = (e.target.value === '') ? '0' : e.target.value
      this.state.price.PriceHourly = reverseFormatCurrency2(value)
    }
    if (name === 'PriceMaterial') {
      let value = (e.target.value === '') ? '0' : transformPercent(e.target.value, true)
      this.state.price.PriceMaterial = reverseFormatCurrency2(value)
    }
    if (name === 'PriceEnvironment') {
      let value = (e.target.value === '') ? '0' : transformPercent(e.target.value, true)
      this.state.price.PriceEnvironment = reverseFormatCurrency2(value)
    }
    if (this.shouldUpdatePrices(this.state.price[e.target.name], this.state.priceOriginal[e.target.name])) {
      this.updatePrices(this.state.price).then((res) => {
        if (name === 'Name') {
          this.props.getPriceLists(this.props)
        }
      })
    }
  }

  changeType (e) {
    let value = parseInt(e.target.value)
    this.setState({
      price: {
        ...this.state.price,
        [e.target.name]: value
      }
    }, () => {
      this.updatePrices(this.state.price).then((res) => {
        this.props.getPriceLists(this.props)
      })
    })
  }

  renderPrices () {
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    if (isCustomer) return null
    // let isCustomer = this.props.customer
    if (this.props.partners) {
      if (hasAccess([2], this.props.auth.user.UserType)) {
        return null
      }
    }
    let { price } = this.state
    let isDisabled = false
    // Render environment discount
    const renderEnviDiscount = () => {
      if (this.shouldRender(1) || hasAccess([6], this.props.auth.user.UserType)) {
        return (
          <Switch
            name='IsEnvironmentDiscount'
            onChange={this.onInputChange}
            checked={price.IsEnvironmentDiscount}
            disabled={false}
            labelText={translation('1236')}
          />
        )
      }
      return null
    }

    // IF Customer
    if ((this.props.customer && price.UseRecommended) || parseInt(this.props.auth.user.ShopId, 10) !== price.ShopId) {
      isDisabled = true
    }
    let priceHourly = formatCurrency2((price.PriceHourly === undefined || price.PriceHourly === '') ? '0' : price.PriceHourly)
    let priceMaterial = transformPercent(formatCurrency2((price.PriceMaterial === undefined || price.PriceMaterial === '') ? '0' : price.PriceMaterial))
    let priceEnvironment = transformPercent(formatCurrency2((price.PriceEnvironment === undefined || price.PriceEnvironment === '') ? '0' : price.PriceEnvironment))
    let mat = '417'
    let ht = '1955'
    if (this.state.department !== 0) {
      mat = '14785'
      ht = '14789'
    }
    // Return
    return (
      <Panel title={translation('13354')}>
        <Text
          name='PriceHourly'
          value={priceHourly}
          onChange={this.onInputChange}
          onBlur={this.onInputBlur}
          disabled={isDisabled}
          labelText={translation('419')}
          helpText={translation('1954')}
        />
        <Text
          name='PriceMaterial'
          value={priceMaterial}
          onChange={this.onInputChange}
          onBlur={this.onInputBlur}
          onFocus={onPercentFocus}
          disabled={isDisabled}
          labelText={translation(mat) + ' (%)'}
          helpText={translation(ht)}
        />
        <Text
          name='PriceEnvironment'
          value={priceEnvironment}
          onChange={this.onInputChange}
          onBlur={this.onInputBlur}
          onFocus={onPercentFocus}
          disabled={isDisabled}
          labelText={translation('13339') + ' (%)'}
          helpText={translation('1956')}
        />

        {hasAccess([6], this.props.auth.user.UserType) && (
          <Text
            name='PriceDiscount'
            value={price.PriceDiscount}
            onChange={this.onInputChange}
            onBlur={this.onInputBlur}
            disabled={isDisabled}
            labelText={translation('1199') + ' (%)'}
          />
        )}

        {renderEnviDiscount()}
      </Panel>
    )
    // return (
    //   <div className='white__box'>
    //     <div className='title'>{translation('13354')}</div>
    //     <div className='form fifty'>
    //       <div className='control__group'>
    //         <label>{translation('419')} <HelpText text={translation('1954')} /></label>
    //         {!isCustomer && (<input type='text' name='PriceHourly' value={priceHourly} onChange={this.onInputChange} onBlur={this.onInputBlur} disabled={isDisabled} />)}
    //         {isCustomer && (<label >{price.PriceHourly}</label>)}
    //       </div>
    //       <div className='control__group'>
    //         <label>{translation(mat)} (%) <HelpText text={translation(ht)} /></label>
    //         {!isCustomer && (<input type='text' name='PriceMaterial' value={priceMaterial} onChange={this.onInputChange} onBlur={this.onInputBlur} onFocus={onPercentFocus} disabled={isDisabled} />)}
    //         {isCustomer && (<label >{transformPercent(price.PriceMaterial)}</label>)}
    //       </div>
    //       <div className='control__group'>
    //         <label>{translation('13339')} (%) <HelpText text={translation('1956')} /></label>
    //         {!isCustomer && (<input type='text' name='PriceEnvironment' value={priceEnvironment} onChange={this.onInputChange} onBlur={this.onInputBlur} onFocus={onPercentFocus} disabled={isDisabled} />)}
    //         {isCustomer && (<label >{transformPercent(price.PriceEnvironment)}</label>)}
    //       </div>
    //       {hasAccess([6], this.props.auth.user.UserType) && (
    //         <div className='control__group'>
    //           <label>{translation('1199')} (%)</label>
    //           {isCustomer && (<input type='text' name='PriceDiscount' value={price.PriceDiscount} onChange={this.onInputChange} onBlur={this.onInputBlur} disabled={isDisabled} />)}
    //           {isCustomer && (<label >{price.PriceDiscount}</label>)}
    //         </div>
    //       )}
    //       {renderEnviDiscount()}
    //     </div>
    //   </div>
    // )
  }

  renderSize () {
    if (this.state.department !== 0) return null
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    // let isCustomer = this.props.customer
    // if (hasAccess([6], this.props.auth.user.UserType) || this.props.partners) return null
    let { price } = this.state
    let isDisabled = this.onlyShow() || isCustomer
    return (
      <Panel title={translation('13340')}>
        <Text
          name='SizeSmall'
          value={transformPercent(price.SizeSmall)}
          onChange={this.onInputChange}
          onBlur={this.onInputBlur}
          onFocus={onPercentFocus}
          disabled={isDisabled}
          labelText={translation('1264') + ' (%)'}
          helpText={translation('1957')}
        />
        <Text value='0' disabled labelText={translation('1265')} helpText={translation('1958')} />
        <Text
          name='SizeLarge'
          value={transformPercent(price.SizeLarge)}
          onChange={this.onInputChange}
          onBlur={this.onInputBlur}
          onFocus={onPercentFocus}
          disabled={isDisabled}
          labelText={translation('1266') + ' (%)'}
          helpText={translation('1959')}
        />
      </Panel>
    )
  }

  renderAddons (dimensions) {
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    if (isCustomer && this.state.price.AddonStartTimes.length === 0 && this.state.price.AddonParts.length === 0) return null
    if (!hasSubscriptionPermission(this.props.auth, 30)) return null

    if (!this.dimensionShow(dimensions)) return null
    // Do not render if estimation type model
    if (this.state.price.PriceType === 5) return null
    if (this.props.partners) {
      if (hasAccess([2], this.props.auth.user.UserType)) {
        return null
      }
    }

    return (
      <TableContainer fullWidth>
        <TableExpand>
          <TableHeader>
            <span>
              {translation('1792')}
              <HelpIcon helpText={translation('1961')} />
            </span>
          </TableHeader>

          {this.state.department === 0 && this.renderAddonStartTimes()}
          {this.renderAddonParts()}
        </TableExpand>
      </TableContainer>
    )
  }

  renderAddonParts () {
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    // let isCustomer = this.props.customer
    // Do not render if estimation type model
    if (isCustomer && this.state.price.AddonParts.length === 0) return null
    if (this.state.price.PriceType === 5) return null
    if (this.props.partners) {
      if (hasAccess([2], this.props.auth.user.UserType)) {
        return null
      }
    }
    let { price } = this.state
    return (
      <PriceItemGroup
        items={price.AddonParts}
        itemClass='addonPart'
        config={getAddonPartConfig(createConfigContext(this.props.auth, this.state.price))}
        onAdd={this.updateOrAddItem}
        onDelete={this.deleteItem}
        onUpdate={this.updateOrAddItem}
        onDragged={this.moveItem}
        disabled={this.state.IsWorking} />
    )
  }

  //     if (typeof newItem.AE !== 'number' || isNaN(newItem.AE)) {
  //       // Toastr
  //       window.toastr.error(translation('13430'), translation('216'))
  //       // Toastr
  //       window.toastr.error(translation('13430'), translation('216'))

  renderAddonStartTimes () {
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    if (isCustomer && this.state.price.AddonStartTimes.length === 0) return null
    // let isCustomer = this.props.customer
    // Do not render if estimation type model
    if (this.state.price.PriceType === 5) return null
    if (this.props.partners) {
      if (hasAccess([2], this.props.auth.user.UserType)) {
        return null
      }
    }

    let { price } = this.state

    return (
      <PriceItemGroup
        items={price.AddonStartTimes}
        itemClass='addonStartTime'
        config={getAddonStartTimeConfig(createConfigContext(this.props.auth, this.state.price))}
        onAdd={this.updateOrAddItem}
        onDelete={this.deleteItem}
        onUpdate={this.updateOrAddItem}
        onDragged={this.moveItem}
        disabled={this.state.IsWorking} />
    )
  }

  renderStartPrice (dimensions, type) {
    if (this.state.department !== 0) return null
    if (!this.dimensionShow(dimensions)) return null
    // Old config.
    // let canEditPrice = !hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()
    // let canEditAE = hasAccess([2], this.props.auth.user.UserType)
    // let canEditMat = hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()
    // let canEditDiscount = hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()
    // let canEditNet = hasAccess([2], this.props.auth.user.UserType) && !this.onlyShow()

    // New config.
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    const isOwnPriceList = parseInt(this.props.auth.user.ShopId, 10) === this.state.price.ShopId

    if (isCustomer && this.state.price.StartPrices.length === 0) return null
    // let isCustomer = this.props.customer
    let canEditPrice = false
    let canEditAE = hasAccess([2, 3, 5, 6, 7], this.props.auth.user.UserType) && !this.props.customer
    let canEditMat = hasAccess([2, 3, 5, 6, 7], this.props.auth.user.UserType) && !this.props.customer // && !this.onlyShow()
    let canEditDiscount = hasAccess([2, 3, 5, 7], this.props.auth.user.UserType) && this.props.customer && isOwnPriceList // && !this.onlyShow()
    let canEditNet = hasAccess([2, 3, 5, 7], this.props.auth.user.UserType) && this.props.customer && isOwnPriceList // && !this.onlyShow()

    let canEditNewAE = hasAccess([2, 3, 5, 6, 7], this.props.auth.user.UserType) && this.props.customer
    let canEditNewMat = hasAccess([2, 3, 5, 6, 7], this.props.auth.user.UserType) && this.props.customer

    let showDiscount = (hasAccess([2, 3, 5, 7], this.props.auth.user.UserType) && this.props.customer) || isCustomer // && !this.onlyShow()
    let showNet = (hasAccess([2, 3, 5, 7], this.props.auth.user.UserType) && this.props.customer) || isCustomer // && !this.onlyShow()

    if (hasAccess([6], this.props.auth.user.UserType) && this.state.price.PriceType === 5) return null
    if (this.props.partners) {
      if (hasAccess([2], this.props.auth.user.UserType)) {
        return null
      }
    }

    const cols = [ 1, [ 7, 2 ], 1 ] // [ 1, 2, 2, 2, 2, 2, 2, 2, 1 ]

    let { price } = this.state
    const deleteItem = (key) => {
      let price = { ...this.state.price }
      price.StartPrices[key].IsDeleted = true
      this.updatePrices(price)
    }
    const renderStartprice = (val, key) => {
      if (val.Type !== type) return null
      const size = 's'

      // let ref1 = 'startPRICE' + type + '_' + val.StartPriceId
      // let ref2 = 'startAE' + type + '_' + val.StartPriceId
      // let ref3 = 'startMAT' + type + '_' + val.StartPriceId
      // let ref4 = 'startNET' + type + '_' + val.StartPriceId
      // let ref5 = 'startDISCOUNT' + type + '_' + val.StartPriceId
      // Edit item
      // const onEditStartprice = (e) => {
      //   // let price = {...this.state.price}
      //   console.log('onEditStartPrice', e.target.name, e.target.value, this.refs[ref5], ref5, this.refs[ref5].value)
      //   let price = JSON.parse(JSON.stringify(this.state.price))
      //   if (e.target.name === 'AE') {
      //     price.StartPrices[key].AE = reverseFormatCurrency2(this.refs[ref2].value, this.AERounding)
      //     if (this.shouldUpdatePrices(price.StartPrices[key].AE, this.state.price.StartPrices[key].AE)) {
      //       this.updatePrices(price).then(() => {
      //         this.refs[ref2].value = formatCurrency2(price.StartPrices[key].AE, this.AERounding)
      //       })
      //     }
      //   } else if (e.target.name === 'Price') {
      //     price.StartPrices[key].Price = reverseFormatCurrency2(this.refs[ref1].value)
      //     if (this.shouldUpdatePrices(price.StartPrices[key].Price, this.state.price.StartPrices[key].Price)) {
      //       this.updatePrices(price).then(() => {
      //         this.refs[ref1].value = formatCurrency2(price.StartPrices[key].Price)
      //       })
      //     }
      //   } else if (e.target.name === 'Mat') {
      //     price.StartPrices[key].Mat = reverseFormatCurrency2(this.refs[ref3].value)
      //     if (this.shouldUpdatePrices(price.StartPrices[key].Mat, this.state.price.StartPrices[key].Mat)) {
      //       this.updatePrices(price).then(() => {
      //         this.refs[ref3].value = formatCurrency2(price.StartPrices[key].Mat)
      //       })
      //     }
      //   } else if (e.target.name === 'Net') {
      //     price.StartPrices[key].Net = reverseFormatCurrency2(this.refs[ref4].value)
      //     if (this.shouldUpdatePrices(price.StartPrices[key].Net, this.state.price.StartPrices[key].Net)) {
      //       this.updatePrices(price).then(() => {
      //         this.refs[ref4].value = formatCurrency2(price.StartPrices[key].Net)
      //       })
      //     }
      //   } else if (e.target.name === 'Discount') {
      //     price.StartPrices[key].Discount = reverseFormatCurrency2(transformPercent(this.refs[ref5].value, true))
      //     if (this.shouldUpdatePrices(price.StartPrices[key].Discount, this.state.price.StartPrices[key].Discount)) {
      //       this.updatePrices(price).then(() => {
      //         this.refs[ref5].value = transformPercent(formatCurrency2(price.StartPrices[key].Discount))
      //       })
      //     }
      //   }
      // }

      const onBlur = (e) => {
        const { name, value } = e
        const { price, priceOriginal } = this.state

        price.StartPrices[key][name] = value

        this.setState({
          price: {
            ...this.state.price,
            StartPrices: price.StartPrices
          }
        }, () => {
          if (this.shouldUpdatePrices(price.StartPrices[key][name], priceOriginal.StartPrices[key][name])) {
            this.updatePrices(price)
          }
        })
      }

      // Functions
      const renderPrice = () => {
        if (canEditPrice) {
          return (
            <DecimalInput
              name='Price'
              value={val.Price}
              onBlur={onBlur}
              size={size}
            />
          )
        }

        return <div className='price'>{formatCurrency2(val.Price)}</div>
      }

      const renderWorkunits = () => {
        if (canEditAE) {
          return (
            <DecimalInput
              name='AE'
              value={val.AE}
              onBlur={onBlur}
              size={size}
            />
          )
        }

        return <div className='workUnits_small'>{formatCurrency2(val.AE, this.AERounding)}</div>
      }

      const renderMat = () => {
        if (canEditMat) {
          return (
            <DecimalInput
              name='Mat'
              value={val.Mat}
              onBlur={onBlur}
              size={size}
            />
          )
        }

        return <div className='mat'>{formatCurrency2(val.Mat)}</div>
      }

      const renderNet = () => {
        if (!showNet) {
          return <div className='net'><span>&nbsp;</span></div>
        }

        if (canEditNet) {
          return (
            <DecimalInput
              name='Net'
              value={val.Net}
              onBlur={onBlur}
              size={size}
            />
          )
        }

        return <div className='Net'>{formatCurrency2(val.Net)}</div>
      }

      const renderDiscount = () => {
        if (!showDiscount) {
          return <div className='discount'><span>&nbsp;</span></div>
        }

        if (canEditDiscount) {
          return (
            <DecimalInput
              name='Discount'
              value={val.Discount}
              onBlur={onBlur}
              onFocus={onPercentFocus}
              transformValue={transformPercent}
              size={size}
            />
          )
        }

        return <div className='discount'>{transformPercent(formatCurrency2(val.Discount))}</div>
      }

      // Return
      return (
        <TableRow cols={cols} key={key}>
          <span>{val.Order}.</span>
          {renderWorkunits()}
          {renderMat()}
          {renderPrice()}
          {renderDiscount()}
          {renderNet()}
          <span>{formatCurrency2(val.Env)}</span>
          <span>{formatCurrency2(val.Total)}</span>

          {!this.onlyShow() && !isCustomer && (
            <RemoveButton onClick={deleteItem.bind(this, key)} disabled={this.state.IsWorking} size='s' />
          )}
        </TableRow>
      )
    }
    const addMoreStartprices = () => {
      let { price } = this.state
      let startPriceKey = 'new_startprice'
      if (type > 0) startPriceKey += type

      let lastEditable = ''
      if (canEditAE) lastEditable = 'AE'
      if (canEditMat) lastEditable = 'Mat'
      if (canEditPrice) lastEditable = 'Price'
      if (canEditDiscount) lastEditable = 'Discount'
      if (canEditNet) lastEditable = 'Net'

      // Functions
      const onChange = (e) => {
        let value = e.target.value
        this.setState({
          [startPriceKey]: {
            ...this.state[startPriceKey],
            [e.target.name]: value
          }
        })
      }
      const formatPrice = (e) => {
        let value = (e.target.value === '') ? '0' : e.target.value
        this.setState({
          [startPriceKey]: {
            ...this.state[startPriceKey],
            [e.target.name]: formatCurrency2(reverseFormatCurrency2(value))
          }
        })
      }
      const onKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === 'Tab') {
          if (e.target.name === lastEditable) {
            addItem()
          }
        }
      }
      const addItem = () => {
        let price = { ...this.state.price }
        let newItem = { ...this.state[startPriceKey] }
        newItem.Price = reverseFormatCurrency2(newItem.Price)
        if (hasAccess([2], this.props.auth.user.UserType)) {
          newItem.Price = 0
        }

        newItem.AE = reverseFormatCurrency2(newItem.AE)
        newItem.Mat = reverseFormatCurrency2(newItem.Mat)
        newItem.Env = reverseFormatCurrency2(newItem.Env)
        newItem.Net = reverseFormatCurrency2(newItem.Net)
        newItem.Discount = reverseFormatCurrency2(newItem.Discount)
        newItem.Type = type

        newItem.Price = (typeof newItem.Price !== 'number' || isNaN(newItem.Price)) ? 0 : newItem.Price
        newItem.AE = (typeof newItem.AE !== 'number' || isNaN(newItem.AE)) ? 0 : newItem.AE
        newItem.Mat = (typeof newItem.Mat !== 'number' || isNaN(newItem.Mat)) ? 0 : newItem.Mat
        newItem.Net = (typeof newItem.Net !== 'number' || isNaN(newItem.Net)) ? 0 : newItem.Net
        newItem.Env = (typeof newItem.Env !== 'number' || isNaN(newItem.Env)) ? 0 : newItem.Env
        newItem.Discount = (typeof newItem.Discount !== 'number' || isNaN(newItem.Discount)) ? 0 : newItem.Discount

        // if (typeof newItem.Price !== 'number' || isNaN(newItem.Price)) {
        //   // Toastr
        //   window.toastr.error(translation('13430'), translation('216'))
        // } else {
        price.StartPrices.push(newItem)
        this.updatePrices(price)
        // }
      }
      // Return
      if (isCustomer) return null

      let count = price.StartPrices.filter(val => { return val.Type === type }).length

      return (
        <TableRow cols={cols}>
          <span>{count + 1}.</span>

          {!(canEditAE || canEditNewAE) && <span />}
          {(canEditAE || canEditNewAE) && <Text name='AE' value={formatCurrency2(this.state[startPriceKey].AE, this.AERounding)} onChange={onChange} onKeyDown={onKeyDown} size='s' />}

          {!(canEditMat || canEditNewMat) && <span />}
          {(canEditMat || canEditNewMat) && <Text name='Mat' value={this.state[startPriceKey].Mat} onChange={onChange} onKeyDown={onKeyDown} size='s' />}

          {!canEditPrice && <span />}
          {canEditPrice && <Text name='Price' value={this.state[startPriceKey].Price} onChange={onChange} onBlur={formatPrice} onKeyDown={onKeyDown} size='s' />}

          {showDiscount && canEditDiscount && (
            <Text name='Discount' value={this.state[startPriceKey].Discount} onChange={onChange} onKeyDown={onKeyDown} size='s' />
          ) || (
            <span />
          )}

          {!canEditNet && <span />}
          {canEditNet && <Text name='Net' value={this.state[startPriceKey].Net} onChange={onChange} onKeyDown={onKeyDown} size='s' />}

          <span />
          <span />

          <AddButton onClick={addItem} disabled={this.state.IsWorking} size='s' />
        </TableRow>
      )
    }

    // Set title depending on startprice type being rendered.
    let title = ''
    let helpText = ''
    switch (type) {
      case 0:
        title = translation('2247')  // car
        helpText = translation('1960')
        break
      case 1:
        title = translation('2246')  // no car
        helpText = translation('1960')
        break
    }

    let mat = '13443'
    if (this.state.department !== 0) {
      mat = '14788'
    }

    return (
      <TableContainer fullWidth>
        <TableExpand>
          <TableHeader>
            <span>
              {title}
              <HelpIcon helpText={helpText} />
            </span>
          </TableHeader>

          <TableRow header cols={cols}>
            <span>{translation('13346')}</span>
            <span>{translation('885')}</span>
            <span>{translation(mat)}</span>
            <span>{translation('641')}</span>

            {showDiscount && (
              <span>{translation('15014')}</span>
            ) || (
              <span>&nbsp;</span>
            )}

            {showNet && (
              <span>{translation('1305')}</span>
            ) || (
              <span>&nbsp;</span>
            )}

            <span>{translation('1044')}</span>
            <span>{translation('393')}</span>
            <span />
          </TableRow>

          {price.StartPrices.map(renderStartprice)}
          {!this.onlyShow() && addMoreStartprices()}
        </TableExpand>
      </TableContainer>
    )
  }

  renderPriceParts (classnameList) {
    if (this.state.parts.length === 0 && this.state.bodyParts.length === 0) return null
    let parts = this.state.parts.length > 0 ? this.state.parts : this.state.bodyParts
    let config = this.state.parts.length > 0 ? getTaskPriceConfig(createConfigContext(this.props.auth, this.state.price)) : getBodyTaskPriceConfig(createConfigContext(this.props.auth, this.state.price))
    if (hasAccess([6], this.props.auth.user.UserType) && this.state.price.PriceType === 5) return <div className='col' />
    // console.log('Sales car - this.props.partners && hasAccess([2], this.props.auth.user.UserType) ', this.props.partners, hasAccess([2], this.props.auth.user.UserType))
    // console.log('renderPriceParts config' , config)
    const showCustomerPartners = this.props.partners && hasAccess([2], this.props.auth.user.UserType)
    // if (this.props.partners) {
    //   if (hasAccess([2], this.props.auth.user.UserType)) {
    //     return (
    //       <div className={classnameList}>
    //         {this.renderStartPrice([[0, 1500]], 0)}
    //         {this.renderStartPrice([[0, 1500]], 1)}
    //         {this.renderAddons([[0, 1500]])}
    //         {this.renderCustomersPartners()}
    //       </div>
    //     )
    //   }
    // }

    const renderContent = () => {
      return (
        <div>
          {this.renderDiscountPrice()}
          {this.renderStartPrice([[0, 10000]], 0)}
          {this.renderStartPrice([[0, 10000]], 1)}
          {this.renderAddons([[0, 10000]])}
          {!showCustomerPartners && parts.map(this.renderTaskPriceParts.bind(this, config))}
          {showCustomerPartners && this.renderCustomersPartners()}
        </div>
      )
    }

    if (classnameList) {
      return (
        <Col span='4'>
          {renderContent()}
        </Col>
      )
    }

    return renderContent()
    // return (
    //   <div className={classnameList}>
    //     {this.renderDiscountPrice()}
    //     {this.renderStartPrice([[0, 1500]], 0)}
    //     {this.renderStartPrice([[0, 1500]], 1)}
    //     {this.renderAddons([[0, 1500]])}
    //     {parts.map(this.renderTaskPriceParts.bind(this, config))}
    //   </div>
    // )
  }

  renderTaskPriceParts (config, val, key) {
    return (
      <PriceItemGroup
        config={config}
        items={val.tasks}
        groupId={val.part.PartItemId}
        title={translation(val.part.DictionaryKey)}
        onAdd={this.updateOrAddItem}
        onDelete={this.deleteItem}
        onUpdate={this.updateOrAddItem}
        onDragged={this.moveItem}
        disabled={this.state.IsWorking}
        key={key} />
    )
  }

  deleteItem (item) {
    item.IsDeleted = true
    this.updateOrAddItem(item)
  }

  moveItem (item, newPosition) {
    if (item.SortIndex === undefined) return // Need sort index to make reordering work.
    let oldSortIndex = item.SortIndex

    let listName = this.getItemListName(item)
    let idField = this.getItemIdField(item)
    let price = { ...this.state.price }
    // if (price.Department === 1) {
    //   if (idField === 'TaskPriceId') {
    //     idField = 'BodyTaskPriceId'
    //     item.BodyTaskPriceId = item.TaskPriceId
    //     item.TaskPriceId = null
    //   }
    //   if (listName === 'TaskPrices') listName = 'BodyTaskPrices'
    //   console.log('item to move ', item)
    // }
    let hasPartId = item.PartItemId !== undefined
    let hasPartItem = item.PartItem !== undefined && item.PartItem.PartItemId !== undefined
    let list = price[listName]
    item.SortIndex = newPosition
    this.setState({ IsWorking: true })
    this.props.reorderPriceListItem(item).then(res => {
      // Assign sortindex from result to all items
      for (let i = 0; i < res.data.length; i++) {
        let listItem = list.find(li => li[idField] === res.data[i][idField])
        if (listItem !== undefined) {
          listItem.SortIndex = res.data[i].SortIndex
        }
      }
    }, () => {
      // If reorder failed on server, revert to old position.
      item.SortIndex = oldSortIndex

      // show error toast
    }).finally(() => {
      // Sort list containing item, to make sure the list and visual dom matches.
      const sorter = (a, b) => {
        if (hasPartId) {
          if (a.PartItemId !== b.PartItemId) return a.PartItemId - b.PartItemId
        } else if (hasPartItem) {
          if (a.PartItem.PartItemId !== b.PartItem.PartItemId) return a.PartItem.PartItemId - b.PartItem.PartItemId
        }
        return a.SortIndex - b.SortIndex
      }

      if (list !== null) {
        list = list.sort((a, b) => sorter(a, b))
        price[listName] = list
        this.setState({
          price: price,
          IsWorking: false
        })
        // console.log('updated list', list.filter((a) => a.SortIndex !== null).map(i => { return { Id: i[this.getItemIdField(i)], TaskName: i.TaskName, SortIndex: i.SortIndex, PartItemId: (hasPartId ? i.PartItemId : i.PartItem.PartItemId) } }))
      }
    })
  }

  updateOrAddItem (item, doPost = true) {
    let idField = this.getItemIdField(item)
    let listName = this.getItemListName(item)
    if (listName === null || idField === null) {
      console.error('Could not update or add item!', item)
      return
    }

    // console.log('Updating item', item, 'adding to ', listName, '(id ' + item[idField] + ')')
    let price = {...this.state.price}
    let list = price[listName]
    if (item[idField] > 0) {
      for (var i; i < list.length; i++) {
        let oldItem = list[i]
        if (oldItem[idField] === item[idField]) {
          list[i] = item
          // updated = true
          break
        }
      }
    } else {
      item[idField] = 0
      list.push(item)
    }
    price[listName] = list

    // Finally send to api.
    if (doPost) {
      this.updatePrices(price)
    }
  }

  getItemIdField (item) {
    // Find id field
    var idFields = []
    var fields = Object.keys(item)
    for (let f in fields) {
      let field = fields[f]
      if (field.toLowerCase().endsWith('id')) {
        idFields.push(field)
      }
    }

    // Determine correct id field.
    for (let f in idFields) {
      if (item[idFields[f]] === undefined || item[idFields[f]] === null || !(typeof item[idFields[f]] === 'number')) continue
      switch (idFields[f].toLowerCase()) {
        case 'bodytaskpriceid':
        case 'taskpriceid':
        case 'estimationtaskid':
        case 'addonstarttimeid':
        case 'addonpartid':
          return idFields[f]
      }
    }
    console.error('Could not determine Id field of item!', item)
    return null
  }

  getItemListName (item) {
    // Find id field
    var idFields = []
    var fields = Object.keys(item)
    for (let f in fields) {
      let field = fields[f]
      if (field.toLowerCase().endsWith('id')) {
        idFields.push(field)
      }
    }
    // console.log('getItemListName id fields', idFields)
    // Determine correct id field.
    for (let f in idFields) {
      if (item[idFields[f]] === undefined || item[idFields[f]] === null || !(typeof item[idFields[f]] === 'number') || item[idFields[f]] < 0) continue
      switch (idFields[f].toLowerCase()) {
        case 'bodytaskpriceid':
          return 'BodyTaskPrices'
        case 'taskpriceid':
          return 'TaskPrices'
        case 'estimationtaskid':
          return 'EstimationTasks'
        case 'addonstarttimeid':
          return 'AddonStartTimes'
        case 'addonpartid':
          return 'AddonParts'
      }
    }

    console.error('Could not determine List name of item!', item)
    return null
  }

  // Should render
  // Customer: 1 - Shop: 2
  shouldRender (type) {
    if (hasAccess([6], this.props.auth.user.UserType)) {
      return type === 2
    }
    // if (this.state.price.Name === null && this.state.price.CustomerId === 0 && type === 2) {
    if (this.state.price.CustomerId === 0 && type === 2) {
      return true
    }
    // if ((this.state.price.Name !== null || this.state.price.CustomerId !== 0) && type === 1) {
    if (this.state.price.CustomerId !== 0 && type === 1) {
      return true
    }
    return false
  }

  switchRecommended (e) {
    let value = (e.target.checked)
    let price = { ...this.state.price }
    price.UseRecommended = value
    this.updatePrices(price)
  }

  renderRecommendedSelector () {
    const DISABLE_RECOMMENDED_TYPES = [-1, 0, 1, 2, 3, 8]
    if (DISABLE_RECOMMENDED_TYPES.find((val) => { val === this.state.price.PriceType }) === undefined) return null
    // if (this.state.price.PriceType <= 3) return null  // Can no longer choose to use recommended rates for undefined, sales, private and warranty.
    // if (!this.state.price.HasParent && (this.state.price.PriceType <= 3)) return null
    if (!hasAccess([3, 4, 7], this.props.auth.user.UserType)) return null
    // if (this.state.price.Name !== null) return null
    // Recommended text
    const recommendedText = () => {
      let translationText = translation('13474')
      if (this.props.customer) {
        return translationText.replace('[NAME]', '')
      }
      return translationText.replace('[NAME]', this.props.auth.user.ChainName)
    }

    // Return
    return (
      <Inline>
        <PanelHeader text={recommendedText()} />
        <Switch name='UseRecommended' onChange={this.switchRecommended} checked={this.state.price.UseRecommended} />
      </Inline>
    )
  }

  renderCustomAgreement () {
    // if (this.state.price.Name === null) return null
    let { price } = this.state
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    // const isDisabled = parseInt(this.props.auth.user.ShopId, 10) !== price.ShopId
    // let isCustomer = this.props.customer
    const renderAgreement = () => {
      const onDelete = () => {
        this.setState({
          confirmDelete: {
            open: true
          }
        })
      }

      const onActive = (e) => {
        this.setState({
          confirmActive: {
            open: true,
            type: e.target.checked ? 1 : 0
          }
        })
      }

      return (
        <Panel title={translation('13472')}>
          <Text name='Name' value={price.Name} onChange={this.onInputChange} onBlur={this.onInputBlur} disabled={isCustomer} labelText={translation('30')} />
          <Switch name='Active' onChange={onActive} checked={price.Active} disabled={isCustomer} labelText={translation('295')} />

          <Inline block>
            {!isCustomer && (
              <Button style='alert' onClick={onDelete} labelText={translation('1822')} />
            )}
            <Button style='link' onClick={this.showPriceModelLog} labelText={translation('1865')} />
          </Inline>

          <PriceModelLogModal priceModelId={price.PriceModelId} show={this.state.showPriceModelLog} onClose={this.showPriceModelLog} />
        </Panel>
      )
      // return (
      //   <div className='white__box'>
      //     <div className='title'>{translation('13472')}</div>
      //     <div className='form fifty'>
      //       <div className='control__group'>
      //         <label>{translation('30')}</label>
      //         {!isCustomer && (<input type='text' name='Name' value={price.Name} onChange={this.onInputChange} onBlur={this.onInputBlur} />)}
      //         {isCustomer && (<label>{price.Name}</label>)}
      //       </div>
      //       <div className='control__group radio__custom__outer'>
      //         <label>{translation('295')}</label>
      //         <div className='radio__custom__wrapper'>
      //           <div className='radio__custom'>
      //             <input type='radio' id='active_yes' name='Active' value='yes' onChange={this.onInputChange} checked={price.Active} disabled={isCustomer} />
      //             <label htmlFor='active_yes'>{translation('47')}</label>
      //           </div>
      //           <div className='radio__custom'>
      //             <input type='radio' id='active_no' name='Active' value='no' onChange={this.onInputChange} checked={!price.Active} disabled={isCustomer} />
      //             <label htmlFor='active_no'>{translation('48')}</label>
      //           </div>
      //         </div>
      //         <div>
      //           {!isCustomer && (<button className='button primary button_half' onClick={onDelete}>{translation('1822')}</button>)}
      //           <button className='button primary button_half' onClick={this.showPriceModelLog} >{translation('1865')}</button>
      //           <PriceModelLogModal priceModelId={price.PriceModelId} show={this.state.showPriceModelLog} onClose={this.showPriceModelLog} />
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // )
    }
    return (
      <div>
        {renderAgreement()}
        {this.renderOrderTypes()}
        {this.renderCustomers()}
        {this.renderBrands()}
      </div>
    )
  }

  showPriceModelLog () {
    this.props.triggerPopup(!this.state.showPriceModelLog)
    this.setState({
      showPriceModelLog: !this.state.showPriceModelLog
    })
  }

  renderSubContractors () {
    if (!hasAccess([600], this.props.auth.user.UserType)) return null
    let { price } = this.state
    // Render sub contractor
    const renderContractor = (item, key) => {
      const onInputBlur = (e) => {
        let price = { ...this.state.price }
        price.PriceModelSubContractors[key][e.target.name] = e.target.value
        this.updatePrices(price)
      }
      const onInputChange = (e) => {
        let price = { ...this.state.price }
        let name = e.target.name.split('_')[0]
        price.PriceModelSubContractors[key][name] = (e.target.value === 'yes')
        this.updatePrices(price)
      }
      // Keys
      let key1 = 'PriceHourly_' + item.SubContractorId + '_' + item.PriceHourly
      let key2 = 'PriceMaterial_' + item.SubContractorId + '_' + item.PriceMaterial
      let key3 = 'PriceEnvironment_' + item.SubContractorId + '_' + item.PriceEnvironment
      let key4 = 'PriceDiscount_' + item.SubContractorId + '_' + item.PriceDiscount
      // Render customers
      let customers = []
      price.PriceModelCustomers.map((val) => {
        if (val.ShopId === item.CompanyId) {
          customers.push(val.CustomerName)
        }
      })
      const customersHtml = "<span class='hint--bottom-left' aria-label='" + customers.join('&#xa;') + "'><img src='/images/icons/menu/Customers-Black.png' /></span>"

      // Return
      return (
        <div className='form fifty' key={key}>
          <strong className='clearfix'>{item.CompanyName} <div dangerouslySetInnerHTML={{ __html: customersHtml }} /></strong>
          <div className='control__group'>
            <label>{translation('419')}</label>
            <input type='text' name='PriceHourly' defaultValue={item.PriceHourly} onBlur={onInputBlur} key={key1} />
          </div>
          <div className='control__group'>
            <label>{translation('13338')} (%)</label>
            <input type='text' name='PriceMaterial' defaultValue={item.PriceMaterial} onBlur={onInputBlur} key={key2} />
          </div>
          <div className='control__group'>
            <label>{translation('13339')} (%)</label>
            <input type='text' name='PriceEnvironment' defaultValue={item.PriceEnvironment} onBlur={onInputBlur} key={key3} />
          </div>
          <div className='control__group'>
            <label>{translation('1199')} (%)</label>
            <input type='text' name='PriceDiscount' defaultValue={item.PriceDiscount} onBlur={onInputBlur} key={key4} />
          </div>
          <div className='control__group radio__custom__outer'>
            <label>{translation('1236')}</label>
            <div className='radio__custom__wrapper'>
              <div className='radio__custom'>
                <input type='radio' id={'discount_yes_' + item.SubContractorId} name={'IsEnvironmentDiscount_' + item.SubContractorId} value='yes' onChange={onInputChange} checked={item.IsEnvironmentDiscount} />
                <label htmlFor={'discount_yes_' + item.SubContractorId}>{translation('47')}</label>
              </div>
              <div className='radio__custom'>
                <input type='radio' id={'discount_no_' + item.SubContractorId} name={'IsEnvironmentDiscount_' + item.SubContractorId} value='no' onChange={onInputChange} checked={!item.IsEnvironmentDiscount} />
                <label htmlFor={'discount_no_' + item.SubContractorId}>{translation('48')}</label>
              </div>
            </div>
          </div>
        </div>
      )
    }

    // Return
    return (
      <Col>
        <Panel title={translation('1737')}>
          {price.PriceModelSubContractors.map(renderContractor)}
        </Panel>
      </Col>
    )
  }

  renderOrderTypes () {
    // let isCustomer = this.props.customer
    if (hasAccess([6], this.props.auth.user.UserType)) return null
    if (hasAccess([3, 7], this.props.auth.user.UserType) && !this.props.customer) return null
    if (hasAccess([2], this.props.auth.user.UserType) && !this.props.partners) return null    // If chain creating work provider..
    // console.log('ordertype', this.props.auth.user.UserType)
    let { price } = this.state
    let isDisabled = (hasAccess([4], this.props.auth.user.UserType)) || parseInt(this.props.auth.user.ShopId, 10) !== price.ShopId
    // Return
    return (
      <Panel title={translation('525')}>
        <Radio name='PriceType' value='1' onChange={this.changeType} checked={price.PriceType === 1} disabled={isDisabled} labelText={translation('71')} />
        <Radio name='PriceType' value='3' onChange={this.changeType} checked={price.PriceType === 3} disabled={isDisabled} labelText={translation('13361')} />
        <Radio name='PriceType' value='2' onChange={this.changeType} checked={price.PriceType === 2} disabled={isDisabled} labelText={translation('785')} />
        <Radio name='PriceType' value='8' onChange={this.changeType} checked={price.PriceType === 8} disabled={isDisabled} labelText={translation('1396')} />
        {this.props.partners && (
          <Radio name='PriceType' value='5' onChange={this.changeType} checked={price.PriceType === 5} labelText={translation('13363')} />
        )}
      </Panel>
    )
    // return (
    //   <div className='white__box'>
    //     <div className='title'>{translation('525')}</div>
    //     <div className='radio__custom__wrapper'>
    //       <div className='radio__custom'>
    //         <input type='radio' id='ordertype_1' name='PriceType' value='1' onChange={this.changeType} checked={price.PriceType === 1} disabled={isCustomer} />
    //         <label htmlFor='ordertype_1'>{translation('71')}</label>
    //       </div>
    //       <div className='radio__custom'>
    //         <input type='radio' id='ordertype_3' name='PriceType' value='3' onChange={this.changeType} checked={price.PriceType === 3} disabled={isCustomer} />
    //         <label htmlFor='ordertype_3'>{translation('13361')}</label>
    //       </div>
    //       <div className='radio__custom'>
    //         <input type='radio' id='ordertype_2' name='PriceType' value='2' onChange={this.changeType} checked={price.PriceType === 2} disabled={isCustomer} />
    //         <label htmlFor='ordertype_2'>{translation('785')}</label>
    //       </div>
    //       <div className='radio__custom'>
    //         <input type='radio' id='ordertype_8' name='PriceType' value='8' onChange={this.changeType} checked={price.PriceType === 8} disabled={isCustomer} />
    //         <label htmlFor='ordertype_8'>{translation('1396')}</label>
    //       </div>
    //       {this.props.partners && (
    //         <div className='radio__custom'>
    //           <input type='radio' id='ordertype_5' name='PriceType' value='5' onChange={this.changeType} checked={price.PriceType === 5} />
    //           <label htmlFor='ordertype_5'>{translation('13363')}</label>
    //         </div>
    //       )}
    //     </div>
    //   </div>
    // )
  }

  renderCustomersPartners () {
    let price = { ...this.state.price }
    // Render shop
    const renderShop = (val, key) => {
      const onChange = (e) => {
        e.persist()
        this.setState({
          ShopId: parseInt(e.target.value),
          customers: []
        }, () => {
          this.props.getCustomers(e.target.value).then((res) => {
            this.setState({
              customers: res.data
            })
          }, () => {
            console.log('Err getting customers')
          })
        })
      }
      return (
        <Radio key={key} labelText={val.ShopName} id={'ShopId_' + val.ShopId} name='ShopId' value={val.ShopId} onChange={onChange} checked={this.state.ShopId === val.ShopId} />
      )
    }
    // Render customer
    const renderCustomer = (val, key) => {
      return (
        <Check key={key} labelText={val.Name} id={'CustomerId_' + val.CustomerId} name='CustomerId' value={val.CustomerId} ref={'CustomerId_' + val.CustomerId} />
      )
    }
    // Add
    const addItems = () => {
      let selectedCustomers = []
      let price = { ...this.state.price }
      Object.keys(this.refs).map((val, key) => {
        if (val.indexOf('CustomerId') !== -1) {
          if (this.refs[val].checked) {
            selectedCustomers.push(val.split('_')[1])
            // Add customer
            price.PriceModelCustomers.push({
              CustomerId: val.split('_')[1]
            })
          }
        }
      })
      if (selectedCustomers.length === 0) {
        // Toastr
        window.toastr.error(translation('1736'), translation('216'))
      } else {
        // Add shop
        price.PriceModelSubContractors.push({
          CompanyId: this.state.ShopId
        })
        // Update prices
        this.updatePrices(price)
      }
    }
    // Render SubContractor
    const renderSubcontractor = (item, key) => {
      let customers = price.PriceModelCustomers.filter((val) => {
        return val.ShopId === item.CompanyId
      })
      if (customers.length === 0) return null
      const renderCustomer = (val, k) => {
        const deleteItem = () => {
          let price = { ...this.state.price }
          price.PriceModelCustomers.map((item) => {
            if (item.CustomerId === val.CustomerId) {
              item.IsDeleted = true
            }
          })
          this.updatePrices(price)
        }
        return (
          <li key={k} className='clearfix'>
            <div className='customer'>
              {val.CustomerName}
            </div>
            <div className='buttonWrap'>
              <RemoveButton onClick={deleteItem} disabled={this.state.IsWorking} size='s' />
            </div>
          </li>
        )
      }
      return (
        <div key={key}>
          <strong>{item.CompanyName}</strong>
          <ul>
            <li />
            {customers.map(renderCustomer)}
          </ul>
        </div>
      )
    }
    // Return
    return (
      <Panel title={translation('14')}>
        <div className='partnerCustomers'>
          <div className='scrollable_list'>
            {this.props.companies.map(renderShop)}
          </div>
          {this.state.customers.length !== 0 && (
            <div className='scrollable_list'>
              {this.state.customers.map(renderCustomer)}
            </div>
          )}
          {this.state.ShopId !== 0 && (
            <Button onClick={addItems} labelText={translation('1208')} />
          )}
          {price.PriceModelSubContractors.length !== 0 && (
            <div className='subcontractors'>
              {price.PriceModelSubContractors.map(renderSubcontractor)}
            </div>
          )}
        </div>
      </Panel>
    )
  }

  renderCustomers () {
    if (hasAccess([6], this.props.auth.user.UserType) || this.props.partners) return null
    if (hasAccess([2, 3, 4, 7], this.props.auth.user.UserType)) return null
    let { price } = this.state
    let { customers } = this.props
    // let ref = 'customersid'

    const onChange = (e) => {
      if (e.target.name === 'customers') {
        this.setState({
          currentCustomer: e.target.value
        })
      }
    }

    // Add customers
    const addItem = () => {
      // let id = parseInt(this.refs[ref].value)
      let id = parseInt(this.state.currentCustomer)

      if (id !== 0) {
        let price = { ...this.state.price }
        price.PriceModelCustomers.push({
          CustomerId: id
        })

        this.updatePrices(price).then(() => {
          // this.refs[ref].value = 0
          this.setState({
            currentCustomer: '0'
          })
        })
      }
    }

    // Render customer
    const renderCustomer = (val, key) => {
      // Delete item
      const deleteItem = (e) => {
        let price = { ...this.state.price }
        price.PriceModelCustomers[key].IsDeleted = true
        this.updatePrices(price)
      }

      // Return
      return (
        <li key={key}>
          <Inline fillChildNum={[0]} block>
            <span>{val.CustomerName}</span>
            <RemoveButton onClick={deleteItem} disabled={this.state.IsWorking} size='s' />
          </Inline>
        </li>
      )
    }

    // Return
    return (
      <Panel title={translation('14')}>
        <Radio name='CustomerSelectionType' value='0' onChange={this.changeType} checked={price.CustomerSelectionType === 0} labelText={translation('381')} />
        <Radio name='CustomerSelectionType' value='1' onChange={this.changeType} checked={price.CustomerSelectionType === 1} labelText={translation('13475')} />

        {price.CustomerSelectionType === 1 && (
          <ul>
            {price.PriceModelCustomers.map(renderCustomer)}

            <li>
              <Inline fillChildNum={[0]} block>
                <DropDown name='customers' value={this.state.currentCustomer} onChange={onChange}>
                  <option value='0'>&nbsp;</option>
                  {customers.map((val, key) => <option value={val.CustomerId} key={key}>{val.Name}</option>)}
                </DropDown>
                <AddButton onClick={addItem} disabled={this.state.IsWorking} size='s' />
              </Inline>
            </li>
          </ul>
        )}
      </Panel>
    )
  }

  renderBrands () {
    // let isCustomer = this.props.customer
    if (hasAccess([6], this.props.auth.user.UserType)) return null
    let { price } = this.state
    let { brands } = this.props
    let isDisabled = (hasAccess([4], this.props.auth.user.UserType)) || parseInt(this.props.auth.user.ShopId, 10) !== price.ShopId
    // console.log('Brands: ', brands.length)
    // let ref = 'brandsid'

    const onChange = (e) => {
      if (e.target.name === 'brands') {
        this.setState({
          currentBrand: e.target.value
        })
      }
    }

    // Add customers
    const addItem = () => {
      // let id = parseInt(this.refs[ref].value)
      let id = parseInt(this.state.currentBrand)

      if (id !== 0) {
        let price = { ...this.state.price }
        price.PriceModelBrands.push({
          BrandId: id
        })

        this.updatePrices(price).then(() => {
          // this.refs[ref].value = 0
          this.setState({
            currentBrand: '0'
          })
          this.props.getPriceLists(this.props)
        })
      }
    }

    // Render brand
    const renderBrand = (val, key) => {
      // Delete item
      const deleteItem = (e) => {
        let price = { ...this.state.price }
        price.PriceModelBrands[key].IsDeleted = true
        this.updatePrices(price).then((res) => {
          this.props.getPriceLists(this.props)
        })
      }

      // Return
      return (
        <Inline fillChildNum={[0]} block key={key}>
          <span>{val.BrandName}</span>
          <RemoveButton onClick={deleteItem} disabled={this.state.IsWorking} size='m' />
        </Inline>
      )
    }

    // Return
    return (
      <Panel title={translation('13473')} helpText={translation('1953')}>
        <Radio name='BrandSelectionType' value='0' onChange={this.changeType} checked={price.BrandSelectionType === 0} disabled={isDisabled} labelText={translation('381')} />
        <Radio name='BrandSelectionType' value='1' onChange={this.changeType} checked={price.BrandSelectionType === 1} disabled={isDisabled} labelText={translation('13475')} />

        {price.BrandSelectionType === 1 && (
          <div className='brands'>
            {price.PriceModelBrands.map(renderBrand)}

            <Inline fillChildNum={[0]} block>
              <DropDown name='brands' value={this.state.currentBrand} onChange={onChange}>
                <option value='0'>&nbsp;</option>
                {brands.map((val, key) => <option value={val.Id} key={key}>{translation(val.Name)}</option>)}
              </DropDown>
              <AddButton onClick={addItem} disabled={this.state.IsWorking} />
            </Inline>
          </div>
        )}
      </Panel>
    )
  }

  // Renders the fixed unit/discount box
  renderDiscountPrice () {
    if (hasAccess([4, 6], this.props.auth.user.UserType)) return null
    if (parseInt(this.props.auth.user.ShopId, 10) !== this.state.price.ShopId) return null
    if (this.state.price.Department !== 0) return null
    // Only show on custom views
    // if (this.state.price.Name === null && this.state.price.CustomerId === 0) return null
    if (this.state.price.CustomerId === 0) return null

    const size = 'm'

    let ref1 = 'discount_unit'
    let ref2 = 'discount_discount'
    // Apply
    const apply = (type, e) => {
      let price = { ...this.state.price }
      if (type === 'unit') {
        price.FixedUnitPrice = reverseFormatCurrency2(this.refs[ref1].value)
        price.FixedDiscount = 0
        price.FixedPriceType = 1
      } else if (type === 'discount') {
        price.FixedUnitPrice = 0
        price.FixedDiscount = reverseFormatCurrency2(this.refs[ref2].value)
        price.FixedPriceType = 2
      }
      this.updatePrices(price).then(() => {
        this.refs[ref1].value = ''
        this.refs[ref2].value = ''
        this.setState({
          confirm: {
            open: false,
            type: 0
          }
        })
      })
    }
    // Format price
    const formatPrice = (e) => {
      let value = (e.target.value === '') ? '0' : e.target.value
      let currencyValue = formatCurrency2(reverseFormatCurrency2(value))
      if (e.target.name === 'unit') {
        this.refs[ref1].value = currencyValue
      } else {
        this.refs[ref2].value = currencyValue
      }
    }
    // Open portal
    const openPortal = (type) => {
      this.setState({
        confirm: {
          open: true,
          type: type
        }
      })
    }
    const renderText = () => {
      return (
        <div>
          {translation('2017')}
        </div>
      )
    }
    // Return
    return (
      <Panel title={translation('2258')}>
        <ul>
          <li>
            <Grid cols={[ 3, 2, 1 ]}>
              <LabelWrapper labelText={translation('13476')} helpText={translation('2080')} />
              <Text name='unit' ref={ref1} onBlur={formatPrice} size={size} />
              <Button style='link' onClick={openPortal.bind(this, 'unit')} labelText={translation('1218')} size={size} />
            </Grid>
          </li>
          <li>
            <Grid cols={[ 3, 2, 1 ]}>
              <LabelWrapper labelText={translation('13477') + ' (%)'} helpText={translation('2081')} />
              <Text name='discount' ref={ref2} onBlur={formatPrice} size={size} />
              <Button style='link' onClick={openPortal.bind(this, 'discount')} labelText={translation('1218')} size={size} />
            </Grid>
          </li>
        </ul>

        {this.state.confirm.open && (
          <Portal className='deleteModal' onPortalClose={this.onPortalClose.bind(this, 'confirm')}>
            <Confirm renderText={renderText} confirm={apply.bind(this, this.state.confirm.type)} notConfirm={this.onPortalClose.bind(this, 'confirm')} />
          </Portal>
        )}
      </Panel>
    )
  }

  renderIndexAdjustments () {
    // Do not render if estimation type model
    if (this.state.price.PriceType === 5) return null

    // console.log('UserType = ', this.props.auth.user.UserType, (this.props.partners ? 'Partner = true' : 'partner = fale'))
    // Render for wp, and shop type users editing a customer
    let access = false
    if (hasAccess([3, 5, 7], this.props.auth.user.UserType) && this.props.customer) access = true
    if (hasAccess([6], this.props.auth.user.UserType)) access = true
    if (parseInt(this.props.auth.user.ShopId, 10) !== this.state.price.ShopId) access = false
    if (access === false) return // Det er sent..

    if (this.props.partners) {  // Do not render for wp/chain
      if (hasAccess([2], this.props.auth.user.UserType)) {
        return null
      }
    }
    let price = { ...this.state.price }
    // let indexAdjustments = [...price.IndexAdjustments]
    const cols = [ 4, 4, 1 ]

    const renderNew = () => {
      let newItem = this.state.new_indexAdjust

      const addItem = () => {
        if (newItem.Date === null || newItem.Date === '') return
        newItem.Date = formatDate(newItem.Date)
        price.IndexAdjustments.push(newItem)
        this.updatePrices(price)
      }

      const onChange = (e) => {
        let value = ''
        let name = ''
        if (typeof e.target !== 'undefined') {
          value = parseFloat(transformPercent(e.target.value, true) || '0')
          name = e.target.name
        } else {
          value = e
          name = 'Date'
        }
        this.setState({
          new_indexAdjust: {
            ...this.state.new_indexAdjust,
            [name]: value
          }
        }, () => {
          // console.log('New index adjust ', this.state.new_indexAdjust)
        })
      }

      let inputProps = {
        name: 'Date',
        placeholder: translation('1728'),
        readOnly: true
      }

      return (
        <Grid cols={cols}>
          <DateTime
            inputProps={inputProps}
            dateFormat='DD-MM-YYYY'
            timeFormat={false}
            closeOnSelect
            value={newItem.Date}
            onChange={onChange}
            size='s'
          />

          <Text size='s' name='Amount' value={transformPercent(newItem.Amount)} onChange={onChange} onFocus={onPercentFocus} />

          <AddButton onClick={addItem} disabled={this.state.IsWorking} size='s' />
        </Grid>
      )
    }

    const renderIndexAdjustLine = (val, key) => {
      const deleteItem = (e) => {
        let price = { ...this.state.price }
        price.IndexAdjustments[key].IsDeleted = true
        this.updatePrices(price)
      }

      return (
        <Grid cols={cols} spacing={1} key={key}>
          <span>{renderFullDate(val.Date, false)}</span>
          <span>{transformPercent(parseFloat(val.Amount))}</span>
          {!val.IsApplied && (
            <RemoveButton onClick={deleteItem} size='s' />
          ) || (
            <span />
          )}
        </Grid>
      )
    }

    let hasIndexAdjustments = price.IndexAdjustments !== undefined

    return (
      <Panel title={translation('1876')} helpText={translation('2085')}>
        <Grid cols={cols}>
          <LabelWrapper labelText={translation('388')} />
          <LabelWrapper labelText={translation('1877') + ' (%)'} />
        </Grid>

        {hasIndexAdjustments && (
          price.IndexAdjustments.map(renderIndexAdjustLine)
        )}

        {renderNew()}
      </Panel>
    )
  }

  renderPriceModelLog () {
    // Do not render if estimation type model
    if (this.state.price.PriceType === 5) return null
    if (this.props.partners) {
      if (hasAccess([2], this.props.auth.user.UserType)) {
        return null
      }
    }

    let log = this.state.log

    const renderLogLine = (val, key) => {
      let changeText = translation('1873')
      let addedText = translation('1874')
      let removedText = translation('1875')

      let text = ''
      let fieldName = ''
      let tableName = ''
      let fromVal = (val.FromText !== null && val.FromText !== '') ? val.FromText : val.From
      let toVal = (val.ToText !== null && val.ToText !== '') ? val.ToText : val.To
      let changedBy = val.ChangedByName
      let changedTime = val.ChangedAt

      switch (val.ChangeTable) {
        case 0:
          tableName = ''
          break
        case 1:
          tableName = translation('1867')
          break
        case 2:
          tableName = translation('1227')
          break
        case 3:
          tableName = translation('13344')
          break
        case 4:
          tableName = translation('13374')
          break
        case 12:
          tableName = translation('1871')
          break
        case 13:
          tableName = translation('1872')
          break
      }
      let mat = '13443'
      if (this.state.department !== 0) {
        mat = '14788'
      }

      switch (val.ChangeField) {
        case 1:
          fieldName = translation('30')
          break
        case 2:
          fieldName = translation('295')
          break
        case 9:
          fieldName = translation('419')
          break
        case 10:
          fieldName = translation(mat)
          break
        case 11:
          fieldName = translation('1044')
          break
        case 12:
          fieldName = translation('1199')
          break
        case 13:
          fieldName = translation('885')
          break
        case 14:
          fieldName = translation('13350')
          break
        case 15:
          fieldName = translation('13431')
          break
        case 16:
          fieldName = translation('1305')
          break
        case 17:
          fieldName = translation('393')
          break
      }

      switch (val.changeType) {
        case 0:
          text = changeText
          break
        case 1:
          text = addedText
          break
        case 2:
          text = removedText
          break
      }
      text = text.replace('[table]', tableName)
      text = text.replace('[field]', fieldName)
      text = text.replace('[fromvalue]', fromVal)
      text = text.replace('[tovalue]', toVal)
      text = text.replace('[user]', changedBy)
      text = text.replace('[time]', changedTime)

      return (
        <li className='clearfix' key={key}>
          <div>{changedTime}</div>
          <div>{text}</div>
        </li>
      )
    }

    return (
      <div className='white__box'>
        <div className='title'>{translation('1866')}</div>
        <ul className='changelog'>
          <li className='clearfix'>
            <div className='date'>{translation('388')}</div>
            <div className='text'>{translation('1489')}</div>
          </li>
          {log.map(renderLogLine)}
        </ul>
      </div>
    )
  }

  onPortalClose (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false
      }
    }, () => console.log(this.state[type]))
  }

  render () {
    if (Object.keys(this.state.price).length === 0) return null
    let extraClass = ''
    let renderPricePartsClass = false
    if (this.props.partners) {
      extraClass += 'partnersPrices'
    }
    if (hasAccess([600], this.props.auth.user.UserType)) {
      renderPricePartsClass = true
      extraClass += ' partnerLoggedIn'
    }
    let renderIndexAdjustmentsRight = hasAccess([600], this.props.auth.user.UserType)
    return (
      <div className={'salescar__screen ' + extraClass}>
        <fieldset disabled={this.props.creating}>
          {this.renderRecommendedSelector()}
          <div className='row clearfix'>
            <Col span='2'>
              {this.renderCustomAgreement()}
              {this.renderPrices()}
              {this.renderSize()}
              {(!renderIndexAdjustmentsRight && this.renderIndexAdjustments())}
              {/* {this.renderStartPrice([[1500, 10000]], 0)}
              {this.renderStartPrice([[1500, 10000]], 1)}
              {this.renderAddons([[1500, 10000]])} */}
              {renderPricePartsClass && this.renderPriceParts('')}
            </Col>
            {!renderPricePartsClass && this.renderPriceParts('col')}
            {this.renderSubContractors()}
            {(renderIndexAdjustmentsRight &&
              <Col>
                {this.renderIndexAdjustments()}
              </Col>)}
          </div>
        </fieldset>
        {this.state.confirmDelete.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmDelete')}>
            <Confirm confirm={this.onConfirm.bind(this, 'confirmDelete')} notConfirm={this.onPortalClose.bind(this, 'confirmDelete')} />
          </Portal>
        )}
        {this.state.confirmActive.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmActive')}>
            <Confirm confirm={this.onConfirm.bind(this, 'confirmActive')} notConfirm={this.onPortalClose.bind(this, 'confirmActive')} renderText={this.getConfirmActiveText} />
          </Portal>
        )}
      </div>
    )
  }

  getConfirmActiveText () {
    let ctext = this.state.confirmActive.type ? 17834 : 17835

    // For WP it's price agreements
    if (hasAccess([6], this.props.auth.user.UserType)) ctext = this.state.confirmActive.type ? 16841 : 16840

    return (
      <div>
        {translation(ctext)}
      </div>
    )
  }

  onConfirm (type) {
    this.onPortalClose(type)
    let price = { ...this.state.price }

    if (type === 'confirmDelete') price.IsDeleted = true
    if (type === 'confirmActive') price.Active = (this.state.confirmActive.type === 1)

    this.updatePrices(price).then(() => {
      this.props.onShouldUpdate()
    })
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    customers: state.common.customers,
    companies: state.common.companies,
    brands: state.common.brands
  }
}

export default connect(mapStateToProps, {
  getPriceList,
  updatePriceList,
  reorderPriceListItem,
  getCustomers,
  // getPriceModelLog,
  triggerPopup,
  getBrands
})(Salescar)



// WEBPACK FOOTER //
// ./src/app/pages/Prices/Salescar/index.js